// extracted by mini-css-extract-plugin
var _1 = "TemplatesView-module__animateUploadProgressBarWidth--D3ThP";
var _2 = "TemplatesView-module__animatedBackground--Msc1G";
var _3 = "TemplatesView-module__container--xWcGM";
var _4 = "TemplatesView-module__empty--V2N8i";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "empty" }
